<template>
	<div id="app">
		<navbar :to="'/film'" />
		
		<div class="movie-top">
			<div class="containner flex item-start" v-if="$store.getters.filmdetail">
				<img :src="'http://124.222.209.62/atstudy-cateye/imgs/film_avat/'+$store.getters.filmdetail.filmWithBLOBs.filmAvat" class="movie-img"/>
				<div class="white text-left ml-40">
					<div class="movie-name weight">{{$store.getters.filmdetail.filmWithBLOBs.filmName}}</div>
					<div class="movie-title bold">{{$store.getters.filmdetail.filmWithBLOBs.filmRealName}}</div>
					<div class="text-md flex mt-20">
						<div class="mr-10" > 
						{{$store.getters.filmdetail.filmWithBLOBs.filmCateKeyword}}
						</div>
					</div>
					<div class="text-md flex mt-5">
						<div class="mr-10">{{$store.getters.filmdetail.filmWithBLOBs.filmRegionKeyword}}</div>
						<div class="mr-10">/</div>
						<div class="mr-10">{{$store.getters.filmdetail.filmWithBLOBs.filmTimelong}}</div>
					</div>
					<div class="text-md flex mt-5">
						<div class="mr-10">{{$store.getters.filmdetail.filmWithBLOBs.filmShowTime}}</div>
						<div class="mr-10">{{$store.getters.filmdetail.filmWithBLOBs.filmShowPlace}}</div>
					</div>
					<div class="mt-30 flex item-end">
						<div class="py-5 mr-40" >
							<div class="flex item-end">
								<button class="movie-btn-small"> 想 看 </button>
								<button class="movie-btn-small ml-10"> 评 分 </button>
							</div>
							<button class="movie-btn-big mt-10"> 特惠购票 </button>
						</div>
						<div class="ml-40">
							<div class="text-sm">猫眼口碑</div>
							<div class="flex item-end">
								<div class="movie-score red weight">{{$store.getters.filmdetail.filmWithBLOBs.filmPraise}}</div>
								<div class="ml-10 py-5">
									<div class="flex item-center">
										<template 
											v-for="i in (1,5)"
											:key="'star-'+i">
											<img src="../assets/star_on.png" class="img-star" 
												v-if="i<=parseInt($store.getters.filmdetail.filmWithBLOBs.filmPraise/2)"/>
											<img src="../assets/star_half.png" class="img-star"
												v-else-if="i-$store.getters.filmdetail.filmWithBLOBs.filmPraise/2<=0.5"/>
											<img src="../assets/star_off.png" class="img-star"
												v-else/>
										</template>
										
									</div>
									<div class="mt-5 text-sm">{{$store.getters.filmdetail.filmWithBLOBs.filmPraisePepole}}人评分</div>
								</div>
							</div>
							<div class="text-sm mt-20">累计票房</div>
							<div class="flex item-end">
								<div class="movie-box weight">{{$store.getters.filmdetail.filmWithBLOBs.filmTotalcost}}</div>
								<div class="mt-5 text-md py-5 ml-5">万</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="containner flex item-start justify-between" v-if="$store.getters.filmdetail">

			<div class="movie-left">
				<div class="movie-left-title">
					<div v-for="(title,index) of titles"
					:class="{active:titlecurrent === index}"
					@click="title_click(index)">{{ title }}</div>					
				</div>
				<div v-if="$store.getters.filmdetail">
					<div v-if="titlecurrent == 0">
						<div class="flex justify-between item-center text-left mt-40 ">
							<div class="text-xl weight gray">演职人员</div>
							<div class="text-sm gray hand">全部 &gt;</div>
						</div>
						<div class="mt-10 flex justify-between item-start">
							<div class="mr-5">
								<div class="text-lg dark my-5 text-left">导演</div>
								<!-- <div v-for="actor in $store.getters.filmdetail.filmActors[0].content"
									:key="actor.act_id">
									<img :src="'/imgs/act_imgs/'+ actor.act_img" class="movie-staff-img hand my-5"/>
									<div class="text-lg dark my-5" 
									:data-id="actor.act_id">
										{{actor.act_name}}
									</div>
								</div> -->
								<div>
									<img :src="'http://124.222.209.62/atstudy-cateye/imgs/act_imgs/'+ $store.getters.filmdetail.filmActors[0].content[0].act_img" class="movie-staff-img hand my-5"/>
									<div class="text-lg dark my-5" 
									:data-id="$store.getters.filmdetail.filmActors[0].content[0].act_id">
										{{$store.getters.filmdetail.filmActors[0].content[0].act_name}}
									</div>
								</div>
								
							</div>
							<div>
								<div class="text-lg dark my-5 text-left ml-10">演员</div>
								<div class="flex item-start justify-between">
									<div class="mx-10"
										v-for="(actor,index) in $store.getters.filmdetail.filmActors[1].content"
										:key="actor.act_id">
										<div v-if="index < 4">
											<img :src="'http://124.222.209.62/atstudy-cateye/imgs/act_imgs/'+ actor.act_img" class="movie-staff-img hand my-5"/>
											<div class="text-lg dark my-5">{{actor.act_name}}</div>
											<div class="text-sm gray my-5">饰：{{actor.act_role}}</div>
										</div>
										
									</div>
								</div>
							</div>
						</div>		
						<div class="mt-40">
							<div class="text-left text-xl weight gray">剧情简介</div>
							<div class="mt-20 text-left text-md dark">{{$store.getters.filmdetail.filmWithBLOBs.filmDesc}}</div>
						</div>
						<div class="mt-40">
							<div class="text-left text-xl weight gray">热门评论</div>
							<comment v-for="comment of $store.getters.filmdetail.comments"
								:key="'comment-'+comment.cmmtId"
								:comment="comment"></comment>
						</div>
						<div class="mt-40p">
							<div class="text-left text-xl weight gray">影片资料</div>
							<div class=" w-100 flex wrap mt-20 bg-gray mb-40">
								<div class="film-attr flex" v-for="(attr,index) in $store.getters.filmdetail.filmAttributes">
									<div>
										<img class="film-attr-img mr-10 ml-40" :src="'http://124.222.209.62/atstudy-cateye/imgs/attr_img/'+ attr.attr_img" alt="">
									</div>
									<div>
										<span class="bold">{{attr.attr_title}}</span><br><br>
										<span class="gray">{{attr.attr_text}}</span>
									</div>
								</div>
							</div>
							

						</div>
					</div>

					<div v-if="titlecurrent == 1">
						<div class="mt-10" v-for="job of $store.getters.filmdetail.filmActors">
							<div class="text-lg dark my-5 text-left">{{job.act_job}}</div>
							<div class="move-left-content">
								<div v-for="actor in job.content"
								:key="actor.act_id">
									<img :src="'http://124.222.209.62/atstudy-cateye/imgs/act_imgs/'+ actor.act_img" class="movie-staff-img hand my-5"/>
									<div class="text-lg dark my-5" 
									:data-id="actor.act_id">
										{{actor.act_name}}
									</div>
								</div>
							</div>
							
						</div>
					</div>

					<div v-if="titlecurrent == 2" class="mt-20">
						<div class="my-20 award-content" v-for="award of $store.getters.filmdetail.filmAwards">
							<div class="text-lg dark my-5 text-left flex item-center">
								<img :src="'http://124.222.209.62/atstudy-cateye/imgs/awd_img/'+ award.awd_img" class="movie-staff-img hand my-5 mr-20"/>
								<div>{{award.awd_name}}</div>
							</div>
							<div class="text-left">
								<div class="mt-10" v-for="(content,index) of award.awd_content"
								:key="index">
								{{content.con_name}}
								</div>
							</div>
							
						</div>
					</div>

					<div v-if="titlecurrent == 3" class="mt-20 flex wrap">
						<div class="my-10" v-for="img of $store.getters.filmdetail.filmImgs">		
							<img :src="'http://124.222.209.62/atstudy-cateye/imgs/film_img/'+ img.img_url" class="movie-staff-img hand my-5 mr-20"/>	
						</div>
					</div>
				</div>
				
			</div>

			<div class="movie-right">
				<div class="movie-left-title">
					<div v-for="(advice,index) of advices"
					:class="{active:advicecurrent === index}"
					@click="advice_click(index)">{{ advice }}</div>					
				</div>

				<div v-if="advicecurrent == 0" class="mt-20">
					<div class="my-20 award-content" v-for="adv of $store.getters.filmdetail.filmAdvances">
						<div class="text-lg dark my-5 text-left flex item-center">
							<img :src="'http://124.222.209.62/atstudy-cateye/imgs/adv_img/'+ adv.adv_img" class="movie-staff-img hand my-5 mr-20"/>
							<div>
								<a :href="adv.adv_link_url">{{adv.adv_title}}</a>
								<div class="flex mt-10">
									<img src="" alt="">
									<div class="text-sm gray">{{adv.adv_watch_count}}</div>
								</div>
								
							</div>
						</div>
						
					</div>
				</div>
				
			</div>

		</div>


		<foot />

	</div>
</template>

<script>
	import navbar from '@/components/navbar.vue'
	import foot from '@/components/foot.vue'
	import comment from '@/components/comment.vue'
	
	export default {
		data () {
			return {
				film: {},
				titles: ["介绍","演职人员","奖项","图集"],
				titlecurrent: 0,
				advices: ["预告片","相关咨询"],
				advicecurrent: 0
			}
		},
		mounted () {
			
			this.$store.dispatch('actFilmload',{payload: this.$route.params.id})
			
			
		},
		components:{
			navbar,
			foot,
			comment
		},
		methods: {
			title_click(index){
				this.titlecurrent = index
			},
			advice_click(index){
				this.advicecurrent = index
			}
		}
	}
</script>

<style>
	/*  影片顶部  */
	.movie-top{ padding-top: 60px; background-image: url(../assets/movie_bg.png); background-repeat: no-repeat; background-position: top center;}
	.movie-img{width: 240px; padding: 4px; background-color: #fff; border-radius: 4px; box-shadow: 0px 0px 10px #999;}
	.movie-name{font-size: 24px;}
	.movie-title{font-size: 18px;}
	.movie-score,.movie-box{font-size: 36px;}
	.img-star{width: 16px;}
	.movie-btn-small{padding: 8px 40px; outline: none; background: rgba(255,255,255,0.5); color: #fff; border: 0px; border-radius: 2px; cursor: pointer; font-size: 14px;}
	.movie-btn-small:hover{background: rgba(255,255,255,0.7);}
	.movie-btn-big{outline: none; padding: 10px 88px; background: rgba(255,100,50,0.5); color: #fff; border: 0px; border-radius: 2px; cursor: pointer; font-size: 14px;}
	.movie-btn-big:hover{background: rgba(255,100,50,0.7);}
	/*  演职人员  */
	.movie-left{width: 800px;}
	.movie-left-title{width: 100%; height: 70px; display: flex; align-items: center; border-bottom: 1px solid rgb(235, 234, 234); margin-top: 15px;}
	.movie-left-title>div{margin-right: 30px; height: inherit; line-height: 70px;}
	.move-left-content{display: flex; flex-wrap: wrap; margin-top: 15px;}
	.active{border-bottom: 2px solid rgb(224, 9, 9); color: rgb(239, 56, 56);}
	.movie-right{width: 380px; margin-left: 20px;}
	.movie-staff-img{ padding: 4px; background-color: #fff; border: 1px solid #eee; border-radius: 4px; }
	.movie-staff-img:hover{background-color: #f9f9f9;}


	.award-content{border-bottom: #999 1px dashed; padding: 20px 0px;}
	.film-attr{width: 394px; color: gray; font-size: 14px; text-align: left;padding: 20px 0px; border-bottom: 1px dashed #999;}
	
	
</style>
